import {Component, Input} from '@angular/core';
import {BiowetterProducts} from '../../../../../../../model/vorhersagen/rbb-document';

@Component({
  selector: 'app-rbb-biowetter-bericht',
  templateUrl: './rbb-biowetter-bericht.component.html',
  styleUrls: ['../../wetterbericht.component.css']
})
export class RbbBiowetterBerichtComponent {

  @Input()
  public biowetter: BiowetterProducts;

}
